/**
 * La forme qu'un mot prend dans la grille : majuscules, sans accent, sans rien d'autre que A–Z.
 *
 * C'est la convention de tous les mots fléchés imprimés, et la seule qui laisse un joueur taper
 * au clavier du téléphone sans chercher le « É ». Les ligatures passent AVANT la décomposition
 * Unicode : NFD ne décompose pas « Œ », qui disparaîtrait sinon avec le filtre final — « ŒIL »
 * deviendrait « IL » et la grille aurait une case de moins que la réponse.
 */
export function gridWord(s: string): string {
  return s
    .replace(/Œ/g, 'OE')
    .replace(/œ/g, 'oe')
    .replace(/Æ/g, 'AE')
    .replace(/æ/g, 'ae')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .replace(/[^A-Z]/g, '');
}

/** Une seule lettre tapée par le joueur, ramenée à la forme de grille — ou '' si ce n'est pas
 *  une lettre. On garde la DERNIÈRE : sur Android, le champ reçoit parfois l'ancienne lettre
 *  et la nouvelle d'un coup. */
export function typedLetter(s: string): string {
  return gridWord(s).slice(-1);
}
